<template>
  <p class="center-content h-[70vh] font-millik text-2xl">An error occurred</p>
</template>

<script>
export default {
    name: 'ErrorPage',
    data() {
        return {
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
    watch: {}
};
</script>

<style></style>
